import { useSelector } from 'react-redux';

import { Selectors, useGetNotificationsQuery } from '../../store/index.js';

interface Props {
    uid?: string;
}

const NotificationBadge: FC<Props> = ({ uid }) => {
    // Get uid from store if not provided
    const uidFromStore = useSelector(Selectors.uid);
    const actualUid = uid || uidFromStore;

    const { data: notifications = [] } = useGetNotificationsQuery({ uid: actualUid }, { skip: !actualUid });

    // Calculate unread notifications count
    const unreadCount = notifications.filter((notification) => !notification.read).length;

    if (unreadCount <= 0) {
        return null;
    }

    // Display 99+ for counts over 99
    const displayCount = unreadCount > 99 ? '99+' : unreadCount.toString();

    return <span className="notification-badge">{displayCount}</span>;
};

export default NotificationBadge;
